
<div class="col-md-12 padding-left-0px padding-right-0px" *ngIf="mode=='view' && isChecked">
  <div class="row margin-left-0px margin-right-0px" *ngIf="field ">
    <div class="col-md-6 text-align-left padding-left-0px padding-right-0px">
      <label class="margin-bottom-0px font-family"> {{field.Title}}</label>
    </div>
    <!--<div class="col-md-1 font-weight-bold margin-top-5px padding-left-0px padding-right-0px">:</div>-->
    <!--<div class="col-md-1 padding-left-0px padding-right-0px text-align-center">


      <input type="checkbox" class="width-15px background-2" [(ngModel)]="field.Value" name="field.Value">






    </div>-->
    <div class="col-md-6 padding-left-0px padding-right-0px">
      <!--<label>{{field.Value}}</label>-->
      <!--<input type="text" class="form-control" [(ngModel)]="field.Remarks" [ngModelOptions]="{standalone: true}"/>-->
      <!--<input type="checkbox" class="width-18px background-2" [(ngModel)]="field.Value" name="field.Value">-->
      <!--<textarea class="form-control3 size-2 width-inherit margin-top-5px margin-left-5px" rows="2" placeholder="Remarks"
            [ngModelOptions]="{standalone: true}"
            [(ngModel)]="field.Remarks" maxlength="100"></textarea>-->
      <!--<input class="form-control remarks" [(ngModel)]="field.Remarks" type="text" [ngModelOptions]="{standalone: true}" />-->
      <!--<label class="margin-bottom-0px margin-top-5px font-weight-normal" ng-hide="field.Remarks==''"><i>({{field.Remarks}})</i></label>-->
      <label class="margin-bottom-0px font-weight-normal font-family" *ngIf="field.Remarks!=null"><i>(Comments:{{field.Remarks}})</i></label>
    </div>
  </div>

  <div class="row margin-left-0px margin-right-0px" *ngIf="field  &&  Data  && Data.HasChildren && isChecked">

    <auto-gen-childrenpv class="col-md-12 padding-left-0px padding-right-0px" [Data]="Data" [field]="Data.Data"
                       [mode]="mode"></auto-gen-childrenpv>

  </div>

</div>




